import type { Cart } from "@repo/core/cart";

import { gTagBeginCheckout } from "@/utils/googleTags";

export function trackBeginCheckout(cart: Cart) {
  gTagBeginCheckout(cart as unknown as Parameters<typeof gTagBeginCheckout>[0]);
}
